import { ExternalView } from "@bitwarden/web-vault/app/models/view/external.view";
import { CollectionAbstraction } from "./collection.abstraction";

export type FetchParams = Record<string, boolean | number | string | object>;

export abstract class ExternalCollection<
  S extends ExternalView = ExternalView,
  T extends FetchParams = FetchParams,
> extends CollectionAbstraction {
  abstract fetch(params: T): Promise<S>;
  protected abstract mapToView(data: any): S;
  abstract triggerChanges(): void;
}
